<template>
    <div class="kf-content kf-content-list kf-content-detail">
        <div class="kf-content-navs">
            <div class="kf-content-nav ">
                <div class="kf-content-nav-icon2 hvr-grow  nac-back-hover" @click="goBack"><i
                        class="iconfont icon-xiangzuo"></i></div>
                <div class="kf-content-box ml5">
                    <div class="kf-content-box-title3" style="margin-top: 3%">{{currProject.name}}</div>
                </div>
                <div class="kf-content-box ml5">
                    <div class="kf-content-box-title3" style="margin-top: 18%">
                        <div class="kf-content-box-title2-icon2"></div>
                    </div>
                </div>
            </div>

        </div>
        <div class="kf-contents">
            <div class="kf-box">
                <div class="kf-box-header">
                    <div class="kf-box-header-left">
                        <div class="kf-box-header-left-icon"><i class="iconfont icon-user"></i></div>
                        <div class="kf-box-header-left-txt ml7" @click="backIndex">首页</div>
                        <div class="kf-box-header-left-icon ml5"><i class="iconfont icon-arrow-right-bold"></i></div>
                        <div class="kf-box-header-left-txt ml7" @click="goBack">{{currMenu.name}}</div>
                        <div class="kf-box-header-left-icon ml5"><i class="iconfont icon-arrow-right-bold"></i></div>
                        <div class="kf-box-header-left-txt ml5">{{currProject.name}}</div>
                    </div>
                    <div class="kf-content-search">
                        <el-input v-model="search" clearable @change="doSearch"
                                  >
                            <template #append><i class="iconfont icon-search" ></i></template>
                        </el-input>
                    </div>
                </div>
                <div class="kf-list-yanshi" v-if="currMenu.code=='demonstrated'">
                    <div class="kf-list-tags" >类型：
                        <div class="kf-list-tags-item"
                             v-for="(item,index) in tagList"
                             :key="index"
                             :class="[currTag==item?'kf-list-tags-item-active':'']"
                             @click="selectTag(item)">{{item}}</div>
                    </div>
                    <div class="kf-box-cons">
                        <div class="kf-box-cons-item "
                             v-for="(item,index) in  dataList"
                             :key="item.uuid">
                            <div class="kf-box-cons-item-img">
                                <div class="kf-hover-box" @click="handleOpen(item)">
                                    <div class="kf-hover-box-header">
                                        <div class="kf-hover-box-header1">
                                            <i class="iconfont icon-user1 ml5 mr2" style="font-size: 12px"></i>
                                              {{item.uploadBy}}
                                        </div>
                                        <div class="kf-hover-box-header1 mr5">上传于{{getTime(item.uploadDate)}}</div>
                                    </div>
                                    <div class="kf-hover-box1">
                                        <img src="../../../styles/img/run.png">
                                    </div>
                                </div>
                                <el-image class="img_wap"
                                          :src="getImageUrl(item)"
                                          :initial-index="1"
                                          @error="doError"
                                          fit="contain"
                                          :lazy="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <img src="../../../styles/img/kf-list1.png">
                                        </div>
                                    </template>
                                </el-image>
                            </div>
                            <div class="kf-box-cons-item-txts">
                                <div class="kf-box-cons-item-txts1">{{item.name}}</div>
                                <div class="kf-box-cons-item-txts2">{{item.tags}}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kf-list-yanshi1" v-else>
                    <div class="kf-box-cons kingfisher_scroll mt5" >
                        <div class="kf-box-cons-thead">
                            <div class="kf-box-cons-th kf-box-cons-th3"
                                 v-if="currMenu.code=='case'||currMenu.code=='demonstrated'">预览图
                            </div>
                            <div class="kf-box-cons-th pl5"
                                 :class="[currMenu.code=='case'||currMenu.code=='demonstrated'?'kf-box-cons-th7':'kf-box-cons-th8']">
                                文件名称
                            </div>
                            <div class="kf-box-cons-th kf-box-cons-th7">文件大小</div>
                            <div class="kf-box-cons-th kf-box-cons-th7">上传人</div>
                            <div class="kf-box-cons-th kf-box-cons-th7">上传时间</div>
                            <div class="kf-box-cons-th kf-box-cons-th6">下载次数</div>
                            <div class="kf-box-cons-th kf-box-cons-th2">操作</div>
                        </div>
                        <div class="kf-box-cons-tbody">
                            <div class="kf-box-cons-thead" v-for="(item, index) in getList1(list)">
                                <div class="kf-box-cons-th kf-box-cons-th3" @click="handleShowVideo(item)"
                                     v-if="currMenu.code=='case'||currMenu.code=='demonstrated'">
                                    <!-- <img src="../../../styles/img/kf-list1.png" class="kf-tbody-img">-->
                                    <!--<img class="kf-tbody-img"
                                         :src="getImageUrl(item)"
                                    />-->
                                    <el-image class="kf-tbody-img"
                                              :src="getImageUrl(item)"
                                              :initial-index="1"
                                              @error="doError"
                                              fit="contain"
                                              :lazy="true"
                                    >
                                    </el-image>
                                </div>
                                <div class="kf-box-cons-th operate_name pl5" @click="handleShowVideo(item)"
                                     :title="item.name"
                                     :class="[currMenu.code=='case'||currMenu.code=='demonstrated'?'kf-box-cons-th7':'kf-box-cons-th8']">
                                    {{item.name}}
                                </div>
                                <div class="kf-box-cons-th kf-box-cons-th7 ">{{item.size}}</div>
                                <div class="kf-box-cons-th kf-box-cons-th7">{{item.uploadBy}}</div>
                                <div class="kf-box-cons-th kf-box-cons-th7">{{getTime(item.uploadDate)}}</div>
                                <div class="kf-box-cons-th kf-box-cons-th6">{{item.updown}}</div>
                                <div class="kf-box-cons-th kf-box-cons-th2 kf-box-cons-operate" @click="handleDown(item)">
                                    <i class="iconfont icon-bottom mr5 operate_i"></i>
                                    <div class="operate_txt">下载</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="kf-pagination-box ">
                <el-pagination  class="mt5" layout="prev, pager, next"
                               :page-size="pageInfo.size"
                               :current-page="pageInfo.pageNo"
                               :total="pageInfo.total"
                               @current-change="changePage"
                ></el-pagination>
            </div>
        </div>
    </div>
    </div>


    <el-dialog custom-class="kf-portal-dialog" title="视频播放" v-model="videoDialog" width="70%"
               top="80px" :close-on-click-modal="false" :show-close="false" height="70%" style="height:70%;">
        <div class="kf-portal-dialog-con">
            <div class="kf-portal-dialog-close" @click="closeDialog"><i class="iconfont icon-close"></i></div>
            <div class="kf-portal-dialog-cons">
                <div class="kf-portal-dialog-cons2">
                    <vue3-video-player :options="getPlayerOptions" :src="getVideoUrl()" ref="video"></vue3-video-player>
                </div>
            </div>
        </div>

    </el-dialog>

</template>

<script>
    import {computed, onMounted, ref, watch} from 'vue'
    import menuModel from '@/model/menu'
    import tools from '@/utils/tools'
    import projectService from '@/service/project'
    import {getToken, removeToken} from "@/utils/auth";
    export default {
        name: "content-deatil",
        setup() {
            let rowLists = ref([]);
            let list = ref([]);
            let search = ref("");
            let pageInfo = ref({"pageNo": 1, "totalRows": 0, "total": 0,"size": 4});
            let host = ref("");
            let videoDialog = ref(false);
            let videoItem = ref({});
            let video = ref(null);
            let url = window.location.href;
            let dataList=ref({});
            let tagList=ref([])
            let currTag=ref('全部');
            let dataNum=ref(4)
            host.value = url.substring(0, url.indexOf("/#/")) + "/portal/";
            const goBack = function () {
                search.value = "";
                menuModel.updateCurrProject({});
            }

            const backIndex = function () {
                search.value = "";
                menuModel.updateCurrMenu({});
            }

            const handleDown = function (item) {
                let downloadUrl = host.value + 'api/repo/kf-details/updown-file/' + item.uuid;
                window.open(downloadUrl, "_self");
                item.updown = item.updown + 1;
            }

            const previewFileFun = (item) => {
                if (item) {
                    window.open(host.value + 'api/repo/kf-details/get-image/' + item.uuid, "_blank");
                }
            };
          const flag=0;
          let typeList=ref([])
            const loadDataList=function (data,flag) {
                let result={};
                result['全部']=[];
                if(data?.length>0){
                  data.forEach(item =>{
                    if(item?.tags && item.tags!=null && item.tags!='') {
                      if (result.hasOwnProperty(item.tags)) {
                        result[item.tags].push(item);
                      } else {
                        result[item.tags] = [];
                        result[item.tags].push(item);
                      }
                    }
                  })
                  result['全部']=data;
                }
                if(flag==0){
                  typeList.value=Object.keys(result)
                }
                return result
            }



            const loadTagesList=function (page, size) {
              list.value = [];
              if (menuModel.currProject.value.uuid && menuModel.currProject.value.uuid != null) {
                if(menuModel.currMenu.value.name=="方案汇总" || menuModel.currMenu.value.name=="资料下载"){
                  size = 9;
                }
                let tag=currTag.value
                if(currTag.value=='全部'){
                  tag=0
                }
                projectService.getDeatil(menuModel.currProject.value.uuid, pageInfo.value.pageNo, dataNum.value,tag,search.value).then(result => {
                  if (result) {
                    pageInfo.value = result.pageInfo;
                    pageInfo.value.size = size;
                    list.value = result.rows;
                    rowLists.value = result.rows;
                    dataList.value=result.rows?result.rows:[];
                  }
                });
              }
            }
          const doSearch=function () {
            loadList(pageInfo.value.pageNo,dataNum.value)
          }
            const loadList = function (page, size,flag) {
                list.value = [];
                if (menuModel.currProject.value.uuid && menuModel.currProject.value.uuid != null) {
                  if(menuModel.currMenu.value.name=="方案汇总" || menuModel.currMenu.value.name=="资料下载"){
                    size = 9;
                  }
                    projectService.getDeatil(menuModel.currProject.value.uuid, page, size,currTag.value,search.value).then(result => {
                        if (result?.rows) {
                            pageInfo.value = result.pageInfo;
                            pageInfo.value.size = size;
                            list.value = result.rows;
                            rowLists.value = result.rows;
                            dataList.value=result.rows?result.rows:[];
                        }
                    });
                }
              if (menuModel.currMenu.value && menuModel.currMenu.value.code =='demonstrated') {
                loadTags()
              }

            }

            const loadSearchList = function (page, size, name) {
                list.value = [];
                if (menuModel.currProject.value.uuid && menuModel.currProject.value.uuid != null) {
                  if(menuModel.currMenu.value.name=="方案汇总"){
                    size = 9;
                  }
                    projectService.getSearchDeatil(menuModel.currProject.value.uuid, page, size, name).then(result => {
                        if (result) {
                            pageInfo.value = result.pageInfo;
                            pageInfo.value.size = size;
                            list.value = result.rows;
                            rowLists.value = result.rows;
                        }
                    });
                }
            }

            watch(() => menuModel.currProject.value, (newValue, oldValue) => {
              if(menuModel.currMenu.value?.code=='demonstrated'){
                dataNum.value=10
              }else{
                dataNum.value=4
              }
                if (newValue !== oldValue) {
                    loadList(1, dataNum.value,0);
                }
            })





            const getImageUrl = function (item) {
                return host.value + 'api/repo/kf-details/get-image/' + item.uuid;
            }


            const changePage = function (page) {
                loadList(page, dataNum.value, 1);
                loadTags()
            }

            const loadTags=function () {
              projectService.getTags(menuModel.currProject.value.uuid,search.value).then(result => {
                tagList.value=result;
              });
            }

            const getImagePreview = function (item) {
                let previewList = [];
                previewList.push(host.value + 'api/repo/kf-details/get-image/' + item.uuid);
                return previewList
            }

            const doError = function (error) {
                console.log("----error--");
                console.log(error);
            }

            const handleShowVideo = function (item) {
                if (menuModel.currMenu.value.code == 'case') {
                    videoDialog.value = true;
                    videoItem.value = item;
                }
                else {
                    let downloadUrl = host.value + 'api/repo/kf-details/get-resource/' + item.uuid;
                    window.open(downloadUrl, "_blank");
                }

            }

            const getVideoUrl = function () {
                return host.value + 'api/repo/kf-details/get-resource/' + videoItem.value.uuid;
            }

            const getPlayerOptions = function () {
                return {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: false, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4", // 类型
                        //src: host.value + 'api/repo/kf-details/get-resource/'+ videoItem.value.uuid+"/"+videoItem.value.type // url地址
                    }],
                    poster: '', // 封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: true, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                    }
                }
            }

            const getTime = function (str) {
                if (str != undefined) {
                    let d = new Date(str);
                    let date = d.getDate();
                    let month = d.getMonth() + 1;
                    let year = d.getFullYear();
                    let h = d.getHours(); //获取小时
                    let m = d.getMinutes(); //获取分钟
                    let s = d.getSeconds(); //获取秒
                    String(date).length < 2 ? (date = "0" + date) : date;

                    String(date).length < 2 ? (date = "0" + date) : date;

                    String(h).length < 2 ? (h = "0" + h) : h;

                    String(m).length < 2 ? (m = "0" + m) : m;

                    String(s).length < 2 ? (s = "0" + s) : s;
                    let timeformat = year + "." + month + "." + date + " " + h + ":" + m + ":" + s;
                    return timeformat.substring(0, 10);
                }
            }


            const handleOpen = function (item) {
              if("demo_web"==menuModel.currMenu.value.type && item.noLogin && item.noLogin==1){
               let  webOpen=item.webUrl+getToken();
                window.open(webOpen, "_blank");
              }else{
                window.open(item.webUrl, "_blank");
              }
            }
            const closeDialog = function () {
                videoDialog.value = false;
                video.value.pause();
            }

            const selectTag=function (tag) {
              currTag.value=tag;
              loadTagesList()
            }
            const getList=function () {
              if(dataList.value && dataList.value.length>0){
                return dataList.value.filter(comp => {
                  return !search.value || tools.pinyinMatch(comp.name, search.value);
                })
              }else{
                return []
              }

            }

            const getList1=function () {
              return list.value.filter(comp => {
                return !search.value || tools.pinyinMatch(comp.name, search.value);
              })
            }

            watch(menuModel.currMenu,(newValue,oldValue) =>{
              if(newValue?.code=='demonstrated'){
                dataNum.value=10
              }else{
                dataNum.value=4
              }
            })

            return {
                search,doSearch,
                currMenu: menuModel.currMenu,
                currProject: menuModel.currProject,
                goBack,
                backIndex,
                handleDown,
                list,
                pageInfo,
                getImageUrl,
                changePage,
                getImagePreview,
                doError,
                videoDialog,
                handleShowVideo,
                videoItem,
                getVideoUrl,
                getPlayerOptions,
                getTime,
                handleOpen,
                video,
                closeDialog,
                previewFileFun,
                dataList,
                tagList,
                currTag,
              selectTag,getList,getList1,typeList
            }
        }
    }
</script>

<style scoped>

</style>